import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AuthLoadingSpinner = ({ 
  message = 'Loading your account...', 
  showLogo = true,
  size = 'default' 
}) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    default: 'w-12 h-12',
    large: 'w-16 h-16'
  };

  const spinnerSizes = {
    small: 'text-lg',
    default: 'text-xl',
    large: 'text-2xl'
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center">
      <div className="absolute top-0 right-0 w-[300px] sm:w-[400px] md:w-[500px] h-[300px] sm:h-[400px] md:h-[500px] bg-gradient-to-br from-blue-200/20 to-purple-200/20 rounded-full filter blur-3xl" />
      <div className="absolute bottom-0 left-0 w-[250px] sm:w-[300px] md:w-[400px] h-[250px] sm:h-[300px] md:h-[400px] bg-gradient-to-tr from-purple-200/20 to-pink-200/20 rounded-full filter blur-3xl" />

      <div className="relative z-10 text-center">
        {showLogo && (
          <div className="mb-8">
            <div className={`flex items-center justify-center ${sizeClasses[size]} bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl text-white shadow-lg mx-auto mb-4`}>
              <FontAwesomeIcon icon="qrcode" className={spinnerSizes[size]} />
            </div>
            <h1 className="text-h3 text-gradient-blue-pink">AM CARDMATE</h1>
          </div>
        )}

        <div className="mb-6">
          <div className="relative">
            <div className="w-16 h-16 border-4 border-blue-200 rounded-full animate-spin mx-auto">
              <div className="w-full h-full border-4 border-transparent border-t-blue-500 rounded-full"></div>
            </div>
            
            <div className="absolute inset-0 w-16 h-16 border-4 border-purple-200 rounded-full animate-spin mx-auto" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}>
              <div className="w-full h-full border-4 border-transparent border-t-purple-500 rounded-full"></div>
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-body-lg font-semibold text-gray-700">{message}</p>
          <div className="flex items-center justify-center space-x-1">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-pink-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>

        <div className="mt-8 bg-white/50 backdrop-blur-sm rounded-2xl p-4 max-w-sm mx-auto">
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center">
                <FontAwesomeIcon icon="check" className="text-xs text-white" />
              </div>
              <span className="text-body-sm text-gray-600">Authenticating user</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-4 h-4 border-2 border-blue-500 rounded-full animate-pulse"></div>
              <span className="text-body-sm text-gray-600">Loading profile data</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-4 h-4 border-2 border-gray-300 rounded-full"></div>
              <span className="text-body-sm text-gray-400">Preparing dashboard</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const MiniAuthSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="flex items-center justify-center gap-3 py-4">
      <div className="relative">
        <div className="w-6 h-6 border-2 border-blue-200 rounded-full animate-spin">
          <div className="w-full h-full border-2 border-transparent border-t-blue-500 rounded-full"></div>
        </div>
      </div>
      <span className="text-body-sm text-gray-600">{message}</span>
    </div>
  );
};

export default AuthLoadingSpinner;